<template>
  <div class="sortable-item sortable-item-inputaudio width-100-pr">
    <span class="sortable-item-info">
      <span class="sortable-item-type">
        Audio <span class="sortable-item-type-position">( {{ index + 1 }} )</span>
      </span>
      <span class="sortable-item-action sortable-item-move">
        <i class="far fa-arrows-alt"></i>
      </span>
      <a
        class="sortable-item-action sortable-item-delete"
        href="#"
        @click.prevent="deleteBlock"
      >
        <i class="far fa-trash-alt"></i>
      </a>
    </span>
    <div class="sortable-item-tag">
      <input
        name="audio"
        :disabled="!canEdit"
        :placeholder="$t('mContentEditorBlockInputAudio.inputs.audio.placeholder')"
        type="text"
        value=""
        @keyup.prevent="insertAudio"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'MoleculeContentEditorBlockInputAudio',

  props: {
    block: Object,
    canEdit: {
      type: Boolean,
      default: true
    },
    index: Number,
    time: {
      type: Number,
      default: null
    }
  },

  methods: {
    deleteBlock () {
      if (this.canEdit) {
        this.$emit('deleteBlock', this.index)
      }
    },

    insertAudio (event) {
      this.$emit('insertAudio', event.target.value, this.index)
    }
  }
}
</script>
